module.exports = __webpack_public_path__ + "img/negative-review.31d1f33b.svg";